export const UNDO_COUNTER = 9000
export const IN_PROGRESS = 'IN_PROGRESS'
export const UNDO_INFO = {
  title: 'Show removed from your Continue Watching list',
  button: 'Undo'
}
